var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatBotProfile = function SvgChatBotProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3AACC8",
    d: "M18 5.195v10.393l-9 5.196-9-5.196V5.195L9 0zm-16.27 1v8.394L9 18.786l7.27-4.197V6.194L9 1.998zm12.575 6.041a7.5 7.5 0 0 1-10.61 0l1.224-1.223a5.77 5.77 0 0 0 8.162 0z"
  })));
};
export { SvgChatBotProfile as ReactComponent };
export default __webpack_public_path__ + "810d63959f5fe3a17f7efc75e8ea3341.svg";